const getRankStyle = (rank) => {
  switch (rank) {
    case 1:
      return "text-2xl font-bold text-yellow-500"; // Gold
    case 2:
      return "text-2xl font-bold text-gray-300"; // Silver
    case 3:
      return "text-2xl font-bold text-yellow-700"; // Bronze
    default:
      return "text-md font-medium text-white"; // Default rank color
  }
};

const getRankText = (botInfo, text) => {
  if (botInfo?.bot?.is_out) {
    return "Out!";
  } else if (botInfo?.metrics?.rank === 0) {
    return "#???";
  } else {
    return `#${text}`;
  }
};

const getEloStyle = (elo) => {
  if (elo < 500) return "text-red-500 font-bold";
  if (elo > 2000) return "text-green-400 font-bold";
  return "text-gray-300 font-bold"; // Default ELO style
};

const formatTimePlayed = (seconds) => {
  const years = Math.floor(seconds / (365 * 24 * 60 * 60)); // Calculate full years
  const days = Math.floor((seconds % (365 * 24 * 60 * 60)) / (24 * 60 * 60)); // Remaining days
  const hours = Math.floor((seconds % (24 * 60 * 60)) / (60 * 60)); // Remaining hours

  // Format the string based on the available time units
  let formattedTime = '';

  
  if (years > 0) formattedTime += `${years} Years`;
  if (days > 0) formattedTime += (formattedTime ? `, ${days} Days` : `${days} Days`);
  if (hours > 0) formattedTime += (formattedTime ? `, ${hours} Hours` : `${hours} Hours`);
  
  return formattedTime;
}

const GlobalStats = ({ botInfo }) => {
  // Example data if botInfo props are not passed

  const {
    bot,
    metrics,
  } = botInfo


  const total_games = metrics.num_losses + metrics.num_wins + metrics.num_draws


  return (
    <div className="py-4 px-8">
      <h2 className="text-2xl font-bold pb-4 text-center border-b border-gray-700">
        Global Stats
      </h2>
      <div className="grid grid-cols-1 gap-y-4 mt-4">
        {/* Rank Section */}
        <div className="flex flex-col space-y-2 border-b border-gray-700 pb-4">
          <span className="font-semibold">Rank:</span>
          <div className="flex justify-between items-center text-gray-400">
            <span>Highest (24h):</span>
            <span className={getRankStyle(metrics.highest_rank)}>
              {getRankText(botInfo, metrics.highest_rank)}
            </span>
          </div>
          <div className="flex justify-between items-center text-gray-400">
            <span>Average (24h):</span>
            <span className={getRankStyle(metrics.avg_rank)}>
              {getRankText(botInfo, metrics.avg_rank)}
            </span>
          </div>
          <div className="flex justify-between items-center text-gray-400">
            <span>Current:</span>
            <span className={getRankStyle(metrics.rank)}>
              {getRankText(botInfo, metrics.rank)}
            </span>
          </div>
        </div>

        {/* ELO Section */}
        <div className="flex flex-col space-y-2 border-b border-gray-700 pb-4">
          <span className="font-semibold">ELO:</span>
          <div className="flex justify-between items-center text-gray-400">
            <span>Highest (24h):</span>
            <span className={getEloStyle(metrics.highest_elo)}>
              {metrics.highest_elo}
            </span>
          </div>
          <div className="flex justify-between items-center text-gray-400">
            <span>Average (24h):</span>
            <span className={getEloStyle(metrics.avg_elo)}>
              {metrics.avg_elo}
            </span>
          </div>
          <div className="flex justify-between items-center text-gray-400">
            <span>Current:</span>
            <span className={getEloStyle(metrics.elo)}>
              {typeof metrics.elo === "string" ? metrics.elo : metrics.elo.toFixed(0)}
            </span>
          </div>
        </div>

        {/* Games Played */}
        <div className="flex flex-col space-y-2 border-b border-gray-700 pb-4">
          <span className="font-semibold">Games Played:</span>
          <div className="flex justify-between items-center text-gray-400">
            <span>Total:</span>
            <span>{total_games}</span>
          </div>
          <div className="flex justify-between items-center text-gray-400">
            <span>Wins:</span>
            <span className="text-green-400">{metrics.num_wins}</span>
          </div>
          <div className="flex justify-between items-center text-gray-400">
            <span>Losses:</span>
            <span className="text-red-400">{metrics.num_losses}</span>
          </div>
          <div className="flex justify-between items-center text-gray-400">
            <span>Draws:</span>
            <span>{metrics.num_draws}</span>
          </div>
        </div>

        {/* Total Time Played */}
        <div className="flex justify-between items-center border-b border-gray-700 pb-4">
          <span className="font-semibold text-gray-400">Total Time Played:</span>
          <span className="text-gray-300">{formatTimePlayed(metrics.time_played_s)}</span>
        </div>
        {metrics.coach_tag && (
          <div className="flex justify-between items-center border-b border-gray-700 pb-4">
            <span className="font-semibold text-gray-400">Coaching progression:</span>
            <div className="relative w-full bg-gray-400/30 rounded-lg h-6">
              <div
                className="h-full text-white bg-blue-950 rounded-lg flex"
                style={{ width: `${metrics.coaching_progression}%` }}
              >
                <p
                  className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-sm font-semibold"
                  style={{ left: `${metrics.coaching_progression}%` }}
                >
                  {metrics.coaching_progression}%
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default GlobalStats;
